const attachmentDefaultOptions = {
  value: '',
  valueType: '',
  column: '1/1',
  allOptions:[],
  fileName: '',
}

export default attachmentDefaultOptions
